// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__12TPo","col":"CardReaderDesc_col__JRXOs","label":"CardReaderDesc_label__2gzGm"};